module.exports = __webpack_public_path__ + "img/Hamochi.6da1938c.png";